import styled, { css } from 'styled-components';
import { colors } from 'constants/colors';
import Flex from 'Components/Grid/Flex';
import { mediaSmDown, mediaSmUp } from 'theme/helpers/css';
import { BorderedModalStyles } from 'Components/Modal/styled';
import { selectByWL } from 'utils/wLabel';
import { WLabel } from 'constants/enums';
import { FontWeight } from 'theme';

// TODO Jira: https://igooods.atlassian.net/browse/FS-175
export const AuthModalStyled = styled.div`
  width: 400px;
  height: 100%;
  padding: 60px 0 20px;
  margin: 0 auto;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: ${colors.white};

  ${mediaSmDown`
    width: auto;
    height: 100%;
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    overflow: auto;
  `}
`;

interface IAuthModalContainer {
  state: string;
}

export const AuthModalContainer = styled.div<IAuthModalContainer>`
  width: 480px;
  height: 600px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;

  ${BorderedModalStyles}

  ${({ state }) => state === 'attempts' && `height: 480px;`}

  ${mediaSmUp`
    margin-bottom: 40px;
  `}

  ${mediaSmDown`
    width: 100%;
    height: 100%;
    align-items: flex-start;
  `}

  ${({ state }) =>
    state === 'loading' &&
    css`
      ${mediaSmDown`
        padding-top: 200px;
      `}
    `}
`;

interface IAuthModalBody {
  isError?: boolean;
}

const wlAuthModalBodyStyles = selectByWL({
  [WLabel.Globus]: `
      .sms-input-group {
          input {
            letter-spacing: 19px;
          }
       }
   `,
});

export const AuthModalBody = styled(Flex).attrs({
  middle: true,
  center: true,
  column: true,
})<IAuthModalBody>`
  ${({ isError }) =>
    isError &&
    `
      input {
        color: ${colors.reddishPink} !important;
      }
      div {
        visibility: visible;
      }
    `}
  ${wlAuthModalBodyStyles}
`;

const wlAuthModalFooterLinkStyles = selectByWL({
  [WLabel.Default]: `color: ${colors.darkBlueGreen};`,
  [WLabel.Globus]: `color: ${colors.simpleOrange};`,
});

export const AuthModalFooter = styled.div`
  color: ${colors.pinkishGrey};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: auto;

  a {
    ${wlAuthModalFooterLinkStyles}
    text-decoration: none;
  }

  ${mediaSmDown`
    text-align: center;
  `}
`;

const wlCodeInputStyles = selectByWL({
  [WLabel.Default]: `font-weight: ${FontWeight.bold};`,
  [WLabel.Globus]: `font-weight: ${FontWeight.extraBold};`,
});

export const CodeInput = styled.input`
  font-size: 34px;
  ${wlCodeInputStyles}
  line-height: 40px;
  -moz-appearance: textfield;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    appearance: none;
    margin: 0;
  }
`;
